import React, { FC, useEffect, useState, useMemo } from 'react'
import { IonModal, IonHeader, IonContent } from '@ionic/react'
import i18n from 'i18next'
import { format, toPrice } from '@dt/fe-utils'
import { getCouponsInfo, formatCardNumber } from '@utils'
import { storeMobx } from 'restaurant'
import ActivityApi from '@api/activity.api'
import { CardIntegralEquity } from '@cps'
import { map, keyBy } from '@dt/fe-utils/dist/lodash'
import './index.scss'

interface IProps {
  type: 'equity' | 'store' | 'integral' | 'recharge' | 'gcDetail' | 'basicAttr';
  cardInfo: any;
  cardType?: 'giftcard' | 'card';
  reject?: () => void;
  resolve?: () => void;
}

const CardEquityModule: FC<IProps> = (props: IProps) => {
  const { type, cardInfo, cardType = 'card', reject, resolve } = props
  const { storeList, storeIdToStore } = storeMobx
  const [couponDetails, setCouponDetails] = useState<any>({})
  const equityTitle = {
    equity: i18n.t('mkt.member.memberDiscountBenefits'),
    store: i18n.t('mkt.member.applyStore'),
    integral: i18n.t('cart.integralRule'),
    recharge: i18n.t('mkt.member.rechargeDes'),
    gcDetail: i18n.t('mkt.member.useRule'),
    basicAttr: i18n.t('mkt.giftCard.basicAttr')
  }
  const deductionRules = {
    rechargeFirst: i18n.t('mkt.member.deductionRule2'),
    average: i18n.t('mkt.member.deductionRule1'),
    giveFirst: i18n.t('mkt.member.deductionRule3')
  }
  const getCoupDetail = (coupons: any[]) => {
    const list: any[] = []
    map(coupons, (i: any) => {
      if (couponDetails[i.couponId]) list.push(`${couponDetails[i.couponId].couponName}${i.couponCnt > 1 ? `*${i.couponCnt}` : ''}`)
    })
    return list
  }
  const handleStoreName = (isAllStore: boolean, storeIds: any[]) => {
    if (isAllStore) {
      return [i18n.t('mkt.member.allStore')]
    } else {
      const list: any = []
      map(storeIds, (i: any) => {
        const findItem = storeIdToStore[i]
        if (findItem) list.push(findItem.storeName)
      })
      return list
    }
  }
  const couponPolicys = useMemo(() => {
    if (type === 'equity' && cardInfo && cardInfo.card.isSendCoupon && cardInfo.card.couponPolicys.length > 0) {
      return keyBy(cardInfo.card.couponPolicys, (item: any) => {
        if (item.sendType === 'action') {
          return `${item.sendType}_${item.sendValue}`
        } else {
          return item.sendType
        }
      })
    } else {
      return {}
    }
  }, [cardInfo])
  useEffect(() => {
    if (type === 'equity' && cardInfo && cardInfo.card.isSendCoupon && cardInfo.card.couponPolicys.length > 0) {
      let coupons: any = []
      cardInfo.card.couponPolicys.map((item: any) => {
        coupons = coupons.concat(item.coupons)
      })
      if (coupons.length > 0) {
        ActivityApi.getCouponsList({ couponIds: getCouponsInfo(coupons) }).then((res: any) => {
          if (res?.length > 0) {
            setCouponDetails(keyBy(res, 'couponId'))
          }
        })
      }
    }
  }, [cardInfo])
  return (
    <IonModal
      cssClass='mkt-card-equity-modal'
      isOpen
      showBackdrop
      swipeToClose
      backdropDismiss
      onDidDismiss={reject}
    >
      <IonHeader className='modal-header'>
        <span>{equityTitle[type]}</span>
        <i data-cypid='clickHeaderBack' className='iconfont icon-close' onClick={reject}></i>
      </IonHeader>
      <IonContent>
        <div className='modal-content'>
          {
            type === 'equity' &&
              <>
                {
                  (cardInfo.card.discountType || cardInfo.card.mallDiscountType) &&
                    <div className='card-info-block'>
                      {cardInfo.card.discountType && <div className='des'>{cardInfo.card?.products?.length ? i18n.t('mkt.member.someMealConsumeGet') : i18n.t('mkt.member.mealConsumeGet')}: {cardInfo.card.discountType === 'memberPrice' ? i18n.t('checkout.memberPrice') : format.toDiscount('discountRate', cardInfo.card.discountValue)}</div>}
                      {cardInfo.card.mallDiscountType && (
                        cardInfo.card.mallDiscountType !== 'discountRate' || (cardInfo.card.mallDiscountType === 'discountRate' && !!cardInfo.card.mallDiscountValue)
                      ) && <div className='des'>{cardInfo.card?.mallProducts?.length ? i18n.t('mkt.member.someMallConsumeGet') : i18n.t('mkt.member.mallConsumeGet')}: {cardInfo.card.mallDiscountType === 'memberPrice' ? i18n.t('checkout.memberPrice') : format.toDiscount('discountRate', cardInfo.card.mallDiscountValue)}</div>}
                    </div>
                }
                {
                  couponPolicys.time &&
                    <div className='card-info-block'>
                      <div className='title'>{i18n.t('mkt.member.couponSend')}</div>
                      <div className='des'>
                        <span>{i18n.t(`mkt.member.sendTime${couponPolicys.time.sendValue}`)}{window.bo === 'cn' ? '。' : '. '}</span>
                        <span>{getCoupDetail(couponPolicys.time.coupons).join(',')}</span>
                      </div>
                    </div>
                }
                {
                  cardInfo.card.type === 'paid' && !cardInfo.expireTime && couponPolicys?.action_receive?.coupons &&
                    <div className='card-info-block'>
                      <div className='title'>{i18n.t('mkt.member.buyCard')}</div>
                      <div className='des'>{getCoupDetail(couponPolicys.action_receive.coupons).join(',')}</div>
                    </div>
                }
                {
                  (couponPolicys.action_renewAndReceive || couponPolicys.action_renew) && cardInfo.card.type === 'paid' &&
                    <div className='card-info-block'>
                      <div className='title'>{i18n.t('mkt.member.openIssue')}</div>
                      <div className='des'>{getCoupDetail((couponPolicys.action_renewAndReceive || couponPolicys.action_renew).coupons).join(',')}</div>
                    </div>
                }
                {
                cardInfo.card?.extra.cardRightsDes &&
                  <div className='card-info-block'>
                    <div className='title'>{i18n.t('mkt.member.memberCardDes')}</div>
                    <div className='des'>{cardInfo.card.extra.cardRightsDes}</div>
                  </div>
                }
                {
                  cardInfo.expireTime &&
                    <div className='card-info-block'>
                      <div className='title'>{i18n.t('mkt.member.cardExpireTime')}</div>
                      <div className='des'>{format.toDateTime(cardInfo.expireTime)}</div>
                    </div>
                }
              </>
          }
          {
            type === 'integral' &&
              <>
                {
                  cardInfo.card.isIntegral &&
                    <div className='card-info-block'>
                      <div className='des'>
                        <CardIntegralEquity cardInfo={cardInfo.card} />
                      </div>
                    </div>
                }
              </>
          }
          {
            type === 'store' &&
              <div className='card-info-block'>
                <div className='des'>
                  {handleStoreName(cardInfo[cardType].isAllStore, cardInfo[cardType].storeIds).join(',')}
                </div>
              </div>
          }
          {
            type === 'recharge' &&
              <>
                {
                  (cardInfo.card.allowAgainLoad || cardInfo.card.allowCustomizeLoad) &&
                    <>
                      <div className='card-info-block'>
                        <div className='des'>
                          <div>{i18n.t('mkt.member.lumpSum')}: {toPrice(cardInfo.balance || 0)} {!!cardInfo.balanceGive && `(${i18n.t('mkt.member.balanceGive', { give: toPrice(cardInfo.balanceGive) })})`}</div>
                          {window.bo === 'cn' && <div>{i18n.t('mkt.member.mallConsume')}: {cardInfo.card.supportMallPay ? i18n.t('mkt.common.available') : i18n.t('mkt.common.unavailable')}</div>}
                          {window.bo !== 'cn' && <div>{i18n.t('mkt.member.tipPayment')}: {cardInfo.card.isPayTip ? i18n.t('mkt.common.available') : i18n.t('mkt.common.unavailable')}</div>}
                          <div>{i18n.t('mkt.member.deductionRules')}: {deductionRules[cardInfo.card.deductionRule]}</div>
                        </div>
                      </div>
                      {
                    cardInfo.card?.extra?.cardRechargeDes &&
                      <div className='card-info-block'>
                        <div className='des'>{cardInfo.card.extra.cardRechargeDes}</div>
                      </div>
                      }
                    </>
                }
              </>
          }
          {
            type === 'gcDetail' &&
              <div className='card-info-block'>
                <div className='des'>
                  {cardInfo.card.description || ''}
                </div>
              </div>
          }
          {
            type === 'basicAttr' &&
              <div className='card-info-block'>
                <div className='des des-line'>
                  <div>
                    <span>{i18n.t('mkt.giftCard.cardClass')}: </span>
                    <span>{cardInfo.giftcard.giftcardName}</span>
                  </div>
                  <div>
                    <span>{i18n.t('mkt.giftCard.cardBalance')}: </span>
                    <span>{format.toPrice(cardInfo.balance)}</span>
                  </div>
                  <div>
                    <span>{i18n.t('mkt.giftCard.cardNumber')}: </span>
                    <span>{formatCardNumber(cardInfo.cardNo)}</span>
                  </div>
                  <div>
                    <span>{i18n.t('mkt.giftCard.currentState')}: </span>
                    <span>{cardInfo.status === 'enable' ? i18n.t('mkt.giftCard.activated') : i18n.t('mkt.giftCard.frozen')}</span>
                  </div>
                  <div>
                    <span>{i18n.t('mkt.giftCard.typesOf')}: </span>
                    <span>{cardInfo.physicalcardId ? i18n.t('mkt.giftCard.plastic') : i18n.t('mkt.giftCard.eleCard')}</span>
                  </div>
                  <div>
                    <span>{i18n.t('mkt.giftCard.validPeriod')}: </span>
                    <span>{cardInfo.expireTime ? cardInfo.expireTime : i18n.t('mkt.giftCard.useRuleExpired1')}</span>
                  </div>
                  {
                    window.bo !== 'cn' &&
                      <div>
                        <span>{i18n.t('mkt.giftCard.payAtip')}: </span>
                        <span>{cardInfo.giftcard.isPayTip ? i18n.t('mkt.common.standBy') : i18n.t('mkt.common.notSupport')}</span>
                      </div>
                  }
                  <div>
                    <span>{i18n.t('mkt.giftCard.giftCardRecharge')}: </span>
                    <span>{cardInfo.giftcard.allowAgainLoad ? i18n.t('mkt.common.standBy') : i18n.t('mkt.common.notSupport')}</span>
                  </div>
                </div>
                {!!cardInfo.giftcard?.description && (
                  <div className='des des-line use-rule'>
                    <span className='use-rule-title'>{i18n.t('mkt.member.useRule')}</span>
                    <div>{cardInfo.giftcard.description}</div>
                  </div>
                )}
              </div>
          }
        </div>
      </IonContent>
    </IonModal>
  )
}

export default CardEquityModule
